import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Patient, PatientListItem } from '../interfaces/patient.interface';

@Injectable({
  providedIn: 'root'
})
export class NavigationHelperService {
  private selectedFacilityIdSubject = new BehaviorSubject<string>('');
  private selectedPatientSubject = new BehaviorSubject<PatientListItem | null | Patient>(null);

  get selectedFacilityId$() {
    return this.selectedFacilityIdSubject.asObservable();
  }

  get selectedPatient$() {
    return this.selectedPatientSubject.asObservable();
  }

  setSelectedFacilityId(facilityId: string) {
    this.selectedFacilityIdSubject.next(facilityId);
  }

  setSelectedPatient(patient: PatientListItem | Patient | null) {
    this.selectedPatientSubject.next(patient);
  }
}
